import { styled } from '@mui/system';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Checkbox, Typography, Tabs, Tab, Grid, Box } from '@mui/material';
import TabPanel from '../../components/tabComponent';
import { useState } from 'react';
import PageTitle from '../../components/PageTitle';

const a11yProps = (index) => ({
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
});

export async function loader({request,params}){
    return null;
}

export async function action({request,params}){
    return null;
}

export default function UserRights() {
    const [tabsValue, setTabsValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabsValue(newValue);
    };

    const data = [
        "Об'єкти",
        "Календар (занятість)",
        "Календар (ціни)",
        "Партнери",
        "Модуль бронювання",
        "Інше"
    ];

    return (
        <Box sx={{maxWidth:'100%', overflow:'auto'}}>
        <PageTitle title="Права користувачів" />
        <Grid container direction="column">
            <Grid item>
                <Tabs value={tabsValue} onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                >
                    <Tab label='Старші менеджери' {...a11yProps(0)} disableRipple />
                    <Tab label='Менеджери' {...a11yProps(1)} disableRipple />
                    <Tab label='Партнери' {...a11yProps(2)} disableRipple />
                </Tabs>
            </Grid>
            <Grid item>
                <TabPanel value={tabsValue} index={0}>
                    <TableComponent data={data} />
                </TabPanel>
                <TabPanel value={tabsValue} index={1}>
                    <TableComponent data={data} />
                </TabPanel>
                <TabPanel value={tabsValue} index={2}>
                    <TableComponent data={data} />
                </TabPanel>
            </Grid>
        </Grid>
        </Box>
    );
}

const TableHeaderComponent = () => (
    <TableRow>
        <TableCell>Розділ</TableCell>
        <TableCell>Перегляд</TableCell>
        <TableCell>Редагування</TableCell>
        <TableCell>Видалення</TableCell>
    </TableRow>
);

const TableRowComponent = ({ right }) => (
    <TableRow>
        <TableCell>{right}</TableCell>
        <TableCell><Checkbox checked={Math.random() > 0.5} /></TableCell>
        <TableCell><Checkbox checked={Math.random() > 0.5} /></TableCell>
        <TableCell><Checkbox checked={Math.random() > 0.5} /></TableCell>
    </TableRow>
);

const TableComponent = ({ data }) => (
    <TableContainer component={Paper}>
        <Table>
            <TableHead style={{ backgroundColor: '#EEEEEE' }}>
                <TableHeaderComponent />
            </TableHead>
            <TableBody>
                {data.map((right) => (
                    <TableRowComponent key={right} right={right} />
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);
